@use '../../../scss/utility';
@use './combobox-list-vars';
@use '../../list-group/list-group-vars';
@use '../../list-group/list-group-item/list-group-item-vars';

:host {
  @include list-group-vars.wb-list-group-vars;
  @include list-group-item-vars.wb-list-group-item-vars;
  @include combobox-list-vars.wb-combobox-list-vars;

  /** @prop --overlay-max-height: max height of the combobox overlay */
  --overlay-max-height: #{utility.wb-pixel-to-rem(280px)};
  /** @prop --chip-list-max-height: max height for the results chips lists inside of the overlay */
  --chip-list-max-height: #{utility.wb-pixel-to-rem(100px)};
}

.overlay {
  box-shadow: var(--wb-shadow-s);
  position: absolute;
  inset-block-start: calc(100% + var(--combobox-list-gap));
  inset-inline: 0;
  z-index: #{utility.$wb-z-index-popover};
  width: 100%;
  max-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: var(--list-group-border-radius);
  background: var(--list-group-background-color);
  opacity: 0;
  transform: translate3d(0, utility.wb-pixel-to-rem(-4px), 0);
  transition:
    opacity var(--combobox-list-overlay-transition-duration) var(--wb-fade),
    transform var(--combobox-list-overlay-transition-duration) var(--wb-move),
    max-height 0s var(--combobox-list-overlay-transition-duration);
  box-sizing: border-box;
  border: var(--list-group-border-weight) solid var(--list-group-border-color);

  @media (prefers-reduced-motion) {
    transition:
      transform 0s,
      max-height 0s;
  }
}

:host(:not([open])) .overlay {
  pointer-events: none;
}

:host([open]) {
  .overlay {
    position: absolute;
    inset-inline: 0;
    inset-block-start: var(--combobox-list-gap);
    min-width: 100%;
    white-space: nowrap;
    height: auto;
    opacity: 1;
    transform: translate3d(0, 0, 0);
    max-height: var(--overlay-max-height);
    transition:
      opacity var(--combobox-list-overlay-transition-duration) var(--wb-fade),
      transform var(--combobox-list-overlay-transition-duration) var(--wb-move),
      max-height 0s 0s;

    @media (prefers-reduced-motion) {
      transition:
        transform 0s,
        max-height 0s;
    }
  }
}

:host([open][list-behaviour='pinned']) {
  .overlay {
    position: fixed;
    min-width: initial;
    margin-block-start: var(--combobox-list-gap);
  }
}

:host([open][list-behaviour='inline']) {
  .overlay {
    position: relative;
    display: grid;
  }
}

.selected-items-list {
  display: inline-flex;
  gap: var(--combobox-list-items-gap);
  flex-wrap: wrap;
}

.no-selection,
.no-results {
  display: inline-flex;
  align-items: center;
  color: var(--list-group-item-meta-color);
}

.no-selection {
  // set static height otherwise row would increase size when chip is added
  // 24px = chip height
  height: utility.wb-pixel-to-rem(24px);
}

.selection-items-wrapper,
.chip-list-wrapper {
  overflow-y: auto;
}

.chip-list-wrapper {
  padding: var(--combobox-list-padding);
  flex-shrink: 0;
  max-height: var(--chip-list-max-height);
  border-block-end: var(--list-group-border-weight) solid var(--list-group-item-border-color);
}

.wb-list-group {
  border: none;
  border-radius: 0;
}

.wb-list-group-item {
  box-sizing: border-box;
}
